import { render } from "./CampanhaModal.vue?vue&type=template&id=2609c37c&scoped=true"
import script from "./CampanhaModal.vue?vue&type=script&lang=js"
export * from "./CampanhaModal.vue?vue&type=script&lang=js"

import "./CampanhaModal.vue?vue&type=style&index=0&id=2609c37c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2609c37c"]])

export default __exports__